import * as React from 'react';
import { MinPriceLabel as MinPriceLabelComponent } from '../../components/MinPriceLabel';
import { getMinPriceLabel } from './helpers';

interface IMinPriceLabelProps {
  price?: number | null;
}

export function MinPriceLabel({ price }: IMinPriceLabelProps) {
  const priceLabel = getMinPriceLabel(price);

  if (!priceLabel) {
    return null;
  }

  return <MinPriceLabelComponent label={priceLabel} />;
}
